import React from "react";

const ErrorScreen = ({ message }) => {
  console.log("ErrorScreen message:", message);
  return (
    <div
      style={{
        textAlign: "center",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {message}
    </div>
  );
};

export default ErrorScreen;
